import xss from 'xss';
import { fingerprint } from './fingerprint';
import url from './url';

export default {
  ...url,
  fingerprint,

  /**
   * 获取Cookie
   * @param key
   * @returns {string}
   */
  getCookie(key) {
    const cookies = document.cookie.split('; ').map(e => e.split('='));
    return new Map(cookies).get(key) || '';
  },

  addScript(url) {
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('async', '');
    script.setAttribute('src', url);
    script.crossOrigin = 'anonymous';
    document.body.appendChild(script);
  },

  isSDK() {
    const wap = url.getURLSearchParam('wap');
    if (wap !== '1') {
      return false;
    }
    const appId = url.getAppId();
    const phoneService = /phoneservice/i.test(navigator.userAgent);
    return appId || phoneService;
  },

  getSDKParams() {
    const params = {};
    if (!this.isSDK()) {
      return params;
    }
    params.wap = '1';
    const redirect = url.getURLSearchParam('redirect');
    const idaasExtField = url.getURLSearchParam('idaas_ext_field');
    if (redirect) {
      params.targetUrl = redirect;
    }
    if (idaasExtField) {
      params.idaasExtField = idaasExtField;
    }
    return params;
  },

  escapeXss(str) {
    return xss(str);
  },
};
